<svg
	class={$$props.class || ''}
	xmlns="http://www.w3.org/2000/svg"
	x="0px"
	y="0px"
	viewBox="0 0 64 64"
	enable-background="new 0 0 64 64"
	xml:space="preserve"
>
	<circle fill="#FFC400" cx="32" cy="32" r="32" />
	<circle fill="#FC594F" cx="54" cy="10" r="5" />
	<polygon
		fill="#FFFFFF"
		points="44.089,23.111 19.911,23.111 19.911,44.089 22.329,44.089 22.329,39.751 22.329,37.191 22.329,35.769 22.329,34.631 22.329,33.209 22.329,32.071 22.329,30.649 22.329,28.089 41.672,28.089 41.672,30.649 41.672,32.071 41.672,33.209 41.672,34.631 41.672,35.769 41.672,37.191 41.672,39.751 41.672,44.089 44.089,44.089 "
	/>
	<path
		fill="#FFFFFF"
		d="M44.48,19.911H19.52c-0.49,0-0.889,0.399-0.889,0.889c0,0.49,0.399,0.889,0.889,0.889h24.96 c0.49,0,0.889-0.399,0.889-0.889C45.369,20.31,44.97,19.911,44.48,19.911z"
	/>
	<path
		fill="#282E35"
		d="M46.791,20.8c0-1.274-1.037-2.311-2.311-2.311H19.52c-1.274,0-2.311,1.037-2.311,2.311 c0,0.902,0.524,1.677,1.28,2.057v22.654h3.84h19.342h3.84V22.857C46.266,22.477,46.791,21.702,46.791,20.8z M45.369,20.8 c0,0.49-0.399,0.889-0.889,0.889H19.52c-0.49,0-0.889-0.399-0.889-0.889c0-0.49,0.399-0.889,0.889-0.889h24.96 C44.97,19.911,45.369,20.31,45.369,20.8z M23.751,37.191h16.498v1.138H23.751V37.191z M23.751,34.631h16.498v1.138H23.751V34.631z M23.751,32.071h16.498v1.138H23.751V32.071z M40.249,30.649H23.751v-1.138h16.498V30.649z M41.672,39.751v-2.56v-1.422v-1.138 v-1.422v-1.138v-1.422v-2.56H22.329v2.56v1.422v1.138v1.422v1.138v1.422v2.56v4.338h-2.418V23.111h24.178v20.978h-2.417V39.751z"
	/> <rect x="23.751" y="29.511" fill="#FFFFFF" width="16.498" height="1.138" />
	<rect x="23.751" y="32.071" fill="#FFFFFF" width="16.498" height="1.138" />
	<rect x="23.751" y="34.631" fill="#FFFFFF" width="16.498" height="1.138" />
	<rect x="23.751" y="37.191" fill="#FFFFFF" width="16.498" height="1.138" />
</svg>
